import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type GetWebhooksQueryVariables = GraphQLTypes.Exact<{
  accountIds?: GraphQLTypes.InputMaybe<Array<GraphQLTypes.Scalars['String']['input']> | GraphQLTypes.Scalars['String']['input']>;
  id?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['String']['input']>;
}>;

export type GetWebhooksQueryResult = { __typename?: 'Query' } & {
  webhookSubscriptionsWebhooks: Array<
    { __typename?: 'WebhookSubscriptionsWebhook' } & Pick<
      GraphQLTypes.WebhookSubscriptionsWebhook,
      'callbackUrl' | 'contactEmail' | 'id' | 'name' | 'topics'
    > & { isDisabled: GraphQLTypes.WebhookSubscriptionsWebhook['disabled'] } & {
        account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id' | 'tradingName'>>;
        headers?: GraphQLTypes.Maybe<
          Array<{ __typename?: 'WebhookHeader' } & Pick<GraphQLTypes.WebhookHeader, 'name' | 'value'>>
        >;
      }
  >;
};

export const GetWebhooksDocument = gql`
  query getWebhooks($accountIds: [String!], $id: String) {
    webhookSubscriptionsWebhooks(accountIds: $accountIds, id: $id) {
      account {
        id
        tradingName
      }
      callbackUrl
      contactEmail
      headers {
        name
        value
      }
      id
      isDisabled: disabled
      name
      topics
    }
  }
`;
